<script>
import { ref, defineAsyncComponent, computed } from "vue";

import MainNavigation from "@/components/MainNavigation.vue";
import {breakpointState} from "@/utils";

export default {
  components:{
      'main-navigation': MainNavigation,
      'stage-slider': defineAsyncComponent(() => import("@/components/StageSlider")),
      'image-teaser': defineAsyncComponent(() => import("@/components/ImageTeaser")),
      'team-slider': defineAsyncComponent(() => import("@/components/TeamSlider")),
      'animated-icons': defineAsyncComponent(() => import("@/components/AnimatedIcons")),
      'portfolio-list': defineAsyncComponent(() => import("@/components/PortfolioList")),
      'to-top': defineAsyncComponent(() => import("@/components/ToTop"))
  },
  setup() {

      const bp = breakpointState.value;

      const mobileNavOpen = ref(false);

      const toggleMobileNav = (state) => {
          if (state !== undefined) {
              mobileNavOpen.value = state;
          } else {
              mobileNavOpen.value = !mobileNavOpen.value;
          }
          mobileNavOpen.value?
              document.body.classList.add("page-header__navigation--active"):
              document.body.classList.remove("page-header__navigation--active");
      }

      const toggleMobileNavClass = computed(() => {
          return {
              'is-active': mobileNavOpen.value
          };
      })

    return {
        mobileNavOpen,
        toggleMobileNav,
        toggleMobileNavClass
    }
  }
}
</script>

<style lang="scss">
@use "@/scss/main.scss";
</style>
